import React from 'react';
import './Card.scss';
import cs from 'classnames';

const Card: React.FC<{ isCarousel?: boolean }> = ({ children, isCarousel }) => (
  <div className={cs('card', { 'card-carousel': isCarousel })}>{children}</div>
);

export default Card;
